import { Provider } from "react-redux";
import { store, persistor } from "@redux";
import { PersistGate } from "redux-persist/integration/react";
import { ModuleMain } from "@modules";
import "@translations/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfigProvider, Modal, notification } from "antd";
import { theme } from "./Utils/theme";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "@components";
import { ModalContext, NotiContext } from "./Utils/hooks";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const [api, contextHolder] = notification.useNotification();
  const [modal, contextModalHolder] = Modal.useModal();

  return (
    <ConfigProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {/* global apply modal with theme token */}
        <ModalContext.Provider value={modal}>
          {contextModalHolder}
          {/* global apply noti msg and applied theme */}
          <NotiContext.Provider value={api}>
            {contextHolder}
            <QueryClientProvider client={queryClient}>
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  <ModuleMain />
                </PersistGate>
              </Provider>
              {process.env.NODE_ENV === "development" && (
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
              )}
            </QueryClientProvider>
          </NotiContext.Provider>
        </ModalContext.Provider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
